import { createFileRoute, redirect } from '@tanstack/react-router'

/** The page moved: Workspaces became Projects — every entity in the tree is
 * a project now, and the separate workspace record is gone. Kept as a
 * redirect so bookmarks and `?sel=` deep links still land; a saved
 * `selKind=workspace` becomes an entity, which is what the row turned into. */
export const Route = createFileRoute('/workspaces')({
  beforeLoad: ({ search }) => {
    const raw = search as { sel?: unknown; selKind?: unknown }
    const sel = typeof raw.sel === 'string' ? raw.sel : undefined
    const selKind =
      raw.selKind === 'server' || raw.selKind === 'repository'
        ? raw.selKind
        : 'entity'
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's documented redirect pattern throws a Redirect object
    throw redirect({ to: '/projects', search: { sel, selKind } })
  },
})
